import React from 'react';
import { Box } from '@mui/material';
import { BRAND_ICON_PATHS } from '../constants/brandIcons';
import { tok } from '../theme/businessTheme';
import { BusinessLink } from '../services/BusinessService';

const Glyph: React.FC<{ platform: string; size: number }> = ({ platform, size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" style={{ flexShrink: 0 }}>
    <path d={BRAND_ICON_PATHS[platform] ?? BRAND_ICON_PATHS.other} />
  </svg>
);

const baseSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 40,
  borderRadius: '20px',
  background: tok('optionRow'),
  color: tok('onBackground'),
  textDecoration: 'none',
  fontFamily: 'inherit',
  transition: 'background-color 120ms, transform 120ms',
  '&:hover': { background: tok('secondaryAction'), color: tok('onSecondaryAction') },
  '&:focus-visible': { outline: `3px solid ${tok('action')}`, outlineOffset: 2 },
} as const;

const BusinessLinks: React.FC<{ links?: BusinessLink[] }> = ({ links }) => {
  if (!links || links.length === 0) return null;
  const sorted = [...links.filter((l) => l.platform === 'google'), ...links.filter((l) => l.platform !== 'google')];
  return (
    <Box component="section" aria-label="Find us online" sx={{ px: 2.5, pt: 2, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px' }}>
      {sorted.map((l, i) => {
        const pill = l.platform === 'google' || l.platform === 'other';
        return (
          <Box
            key={`${l.url}-${i}`}
            component="a"
            href={l.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={l.label}
            title={l.label}
            sx={{
              ...baseSx,
              ...(pill
                ? { gap: 1, px: 1.75, fontSize: 14, fontWeight: 600, maxWidth: '100%', minWidth: 0 }
                : { width: 40 }),
            }}
          >
            <Glyph platform={l.platform} size={pill ? 18 : 20} />
            {pill && (
              <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.label}</Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default BusinessLinks;
